import { create } from 'zustand';
import { UserSchema } from './schema';
import { UserModel } from '../../../../main/users-facility/api/types';
import { cropModel, initialUserData, ModalType } from './types';
import { UserRoles } from '../../../enums/user-roles';

export interface UserInvitationState {
    isModalOpen: boolean;
    pageSize: number;
    pageNumber: number;
    queryData: UserSchema;
    currentModalType: ModalType;
    selectedUser: UserModel | undefined;
    modalTitle: string;
    modalSubtitle: string;
    previewUrl: string | null;
    previewUrl2: string | null;
    originalFileName: string;
    openCropDialog: boolean;
    zoom: number;
    crop: { x: number; y: number },
    croppedAreaPixels: cropModel | null,
    defaultRoleValue: UserRoles | undefined,
    clearingUserForm: boolean,
    prefillUserData: Partial<UserSchema> | null;
    setPrefillUserData: (data: Partial<UserSchema>) => void;
    setClearingUserForm: (val: boolean) => void
    setDefaultRoleValue: (val: UserRoles | undefined) => void;
    setCroppedAreaPixels: (val: cropModel | null) => void;
    setCrop: (val: { x: number; y: number }) => void;
    setZoom: (val: number) => void;
    setOpenCropDialog: (val: boolean) => void;
    setOriginalFileName: (val: string) => void;
    setPreviewUrl2: (val: string | null) => void;
    setPreviewUrl: (val: string | null) => void;
    setModalSubtitle: (val: string) => void;
    setModalTitle: (val: string) => void;
    callback: () => void
    setCallback: (val: () => {}) => void;
    setSelectedUser: (val: UserModel | undefined) => void;
    setCurrentModalType: (val: ModalType) => void;
    setQueryData: (val: UserSchema) => void;
    setPageSize: (val: number) => void;
    setPageNumber: (val: number) => void;
    setModal: (val: boolean) => void;
}

const useUserInvitationStore = create<UserInvitationState>((set) => ({
    isModalOpen: false,
    pageSize: 10,
    pageNumber: 1,
    queryData: initialUserData,
    currentModalType: ModalType.QueryForm,
    selectedUser: undefined,
    modalTitle: "",
    modalSubtitle: "",
    previewUrl: null,
    previewUrl2: null,
    originalFileName: "",
    openCropDialog: false,
    zoom: 1,
    crop: { x: 0, y: 0 },
    croppedAreaPixels: null,
    defaultRoleValue: undefined,
    clearingUserForm: false,
    prefillUserData: null,
    setPrefillUserData: (data) => set({ prefillUserData: data }),
    setClearingUserForm: (clearingUserForm: boolean) => set(() => ({ clearingUserForm })),
    setDefaultRoleValue: (defaultRoleValue: UserRoles | undefined) => set(() => ({ defaultRoleValue })),
    setCroppedAreaPixels: (croppedAreaPixels: cropModel | null) => set(() => ({ croppedAreaPixels })),
    setCrop: (crop: { x: number; y: number }) => set(() => ({ crop })),
    setZoom: (zoom: number) => set(() => ({ zoom })),
    setOpenCropDialog: (openCropDialog: boolean) => set(() => ({ openCropDialog })),
    setOriginalFileName: (originalFileName: string) => set(() => ({ originalFileName })),
    setPreviewUrl2: (previewUrl2: string | null) => set(() => ({ previewUrl2 })),
    setPreviewUrl: (previewUrl: string | null) => set(() => ({ previewUrl })),
    setModalSubtitle: (modalSubtitle: string) => set(() => ({ modalSubtitle })),
    setModalTitle: (modalTitle: string) => set(() => ({ modalTitle })),
    callback: () => { },
    setCallback: (callback: () => void) => set(() => ({ callback })),
    setSelectedUser: (selectedUser: UserModel | undefined) => set(() => ({ selectedUser })),
    setCurrentModalType: (currentModalType: ModalType) => set(() => ({ currentModalType })),
    setQueryData: (queryData: UserSchema) => set(() => ({ queryData })),
    setPageSize: (pageSize: number) => set(() => ({ pageSize })),
    setPageNumber: (pageNumber: number) => set(() => ({ pageNumber })),
    setModal: (isOpen: boolean) => set({ isModalOpen: isOpen }),
}));

export default useUserInvitationStore;